module.exports = __webpack_public_path__ + "media/src/assets/background-5d0ad0a65a61f42bc2435297be7c345a.png";